import React, { type ComponentClass } from 'react';
import { raw } from '@aha-app/mvc';
import type WhiteboardController from '../controllers/WhiteboardController';
import { makeTestId } from '../utils/tools';

// The base class for drawing instruments that create or manipulate objects
// on the canvas.
class Stylus {
  stylusType?: string;
  controller: WhiteboardController;

  constructor({ controller }: { controller: WhiteboardController }) {
    this.controller = controller;
  }

  // Activate the stylus.
  activate() {
    this.controller.canvas.isDrawingMode = false;
    this.controller.canvas.brush = false;
  }

  // Component to render for the stylus sub-menu (if any).
  subMenu(): ComponentClass<any, any> | React.FC | null {
    return null;
  }

  // If a stylus exists within a toolbar submenu, override this method and
  // return the name of that submenu.
  subMenuName(): string | null {
    return null;
  }

  // Returns if a stylus always be locked when selected (i.e. pen)
  alwaysLockWhenSelected() {
    return false;
  }

  // After an object has been drawn determine if we will do something else.
  // By default we switch back to the pointer.
  drawingComplete() {
    this.controller.actionResetStylus();
  }

  isPointer() {
    return this.stylusType === 'pointer';
  }

  // Check if this stylus (or a submenu) is the current one.
  isCurrentStylus(currentStylus) {
    return (
      raw(currentStylus) === raw(this) ||
      (currentStylus.subMenuName() !== null &&
        currentStylus.subMenuName() === this.subMenuName())
    );
  }

  // Fontawesome icon class to use in the toolbar.
  iconClass() {
    return 'fas fa-square-question';
  }

  renderIcon() {
    return <aha-icon icon={this.iconClass()} />;
  }

  // Optional method for custom menu components
  menuComponent(): React.ReactElement | undefined {
    return undefined;
  }

  // Override in subclass to return a description of the stylus.
  description() {
    return 'Stylus';
  }

  // CSS cursor to use when the sylus is active.
  // TODO: We can also support custom cursors.
  cursor() {
    return 'default';
  }

  toolButtonClass(): string | undefined {
    return undefined;
  }

  testid() {
    return `Stylus-${makeTestId(this.description())}`;
  }

  stylusId() {
    throw new Error('stylusId must be implemented in subclass');
  }

  isPromotion() {
    return false;
  }

  renderTryPill() {
    if (this.isPromotion()) {
      return (
        <aha-promo-try-pill
          border-color='white'
          font-sizing='small'
          pill-size='small'
          style={{
            fontSize: '8px',
            position: 'relative',
            top: '-44px',
            right: '-22px',
            height: '0',
            width: '0',
            display: 'block',
            cursor: 'default',
          }}
        />
      );
    }
  }
}

export default Stylus;
